import { render } from "./PointLayerLegend.vue?vue&type=template&id=18097d8f&scoped=true"
import script from "./PointLayerLegend.vue?vue&type=script&lang=js"
export * from "./PointLayerLegend.vue?vue&type=script&lang=js"

import "./PointLayerLegend.vue?vue&type=style&index=0&id=18097d8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18097d8f"]])

export default __exports__